// Sort numbers
export const number = (a, b) => a - b;
// Sort strings
export const string = (a, b) => {
    if (typeof a !== 'string') return -1;
    if (typeof b !== 'string') return 1;
    return a.localeCompare(b, undefined, { sensitivity: 'base' });
};

// Sort dates
export const date = (a, b) => new Date(a) - new Date(b);

// Sort booleans
export const boolean = (a, b) => (a === b ? 0 : a ? -1 : 1);
